<template>
  <div class="rf_id_scan_info">
    <el-row type="flex" class="info-section">
      <el-col :span="20">
        <div class="scaninfo">
          <div class="c1">{{ scanTypeLabel }}</div>
          <div class="c1">{{ taskInfo }}</div>
          <div class="c2">{{ packageTypeLabel }}</div>
        </div>
      </el-col>
      <el-col :span="4">
        <div :class="{
          'mode':true,
          'del':isdel
        }">{{ caijiBtnText }}
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="device-section">
        <span class="shebeiip">设备ip</span>
        <el-form class="shebeiinput">
          <el-form-item>
            <el-input v-model="_value"></el-input>
          </el-form-item>
        </el-form>
        <div class="btns">
          <div v-if="hasSupplierOrRepairFactory && (isNewPackageIn || isRepairIn)">
            <div class="container">
              <div>*{{ isNewPackageIn ? '供应商' : '维修工厂' }}：</div>
              <div class="supplier">{{ isNewPackageIn ? selectedSupplier.label : selectedRepairFactory.label }}</div>
              <el-button type="success"
                         @click="showSupplierOrRepairFactoryDialog(isNewPackageIn ? 'supplier' : 'repairFactory')">
                {{ (isNewPackageIn ? selectedSupplier.value : selectedRepairFactory.value) ? '修改' : '请选择' }}
              </el-button>
            </div>
            <div style="min-height: 3rem" class="container" v-if="hasSupplierOrRepairFactory && isRepairIn">
              <div style="margin-right: 2rem">*维修类型：</div>
              <el-radio-group :disabled="deviceStatus===1||deviceStatus===1.1" style="transform: scale(1.4)" v-model="form.repairType">
                <el-radio style="margin-right: 0.5rem" v-model="form.repairType" label="0">普通维修</el-radio>
                <el-radio v-model="form.repairType" label="1">拼接维修</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="btns-opts">
            <div>
              <el-button type="success" @click="startClick" :disabled="deviceStatus===1||deviceStatus===1.1">开始
              </el-button>
            </div>
            <div>
              <el-button type="primary" @click="stopEcpClick" :disabled="deviceStatus!==1">关闭</el-button>
            </div>
            <div>
              <el-button type="danger" @click="abandonScanClick" :disabled="deviceStatus!=0">放弃本次扫描</el-button>
            </div>
            <div v-if="scanType=='40'" style="display: flex;width: 100%;align-items: center;justify-content: center;">
              <label style="font-size: 10pt;margin-right: 5px;">维修包签</label>
              <el-input style="width: 170px" v-model="repairPackageData"
                        ref="inputRef"
                        class="bag-sign"
                        placeholder="上传前请输入维修包签"
                        :disabled="checkStatus === true"
                        @keydown.enter.native="checkRepairPackageData"/>
              <el-button plain type="primary" size="small"
                         style="margin-left: 4px"
                         @click="editOrCheckRepairPackageData">
                {{ checkBtnText }}
              </el-button>
            </div>
          </div>
          <div class="btns-upload" style="margin-top: 20px">
            <div style="color: red;margin-bottom: 15px;font-size: 18pt;text-align: left">
              请注意：当前上传的堆数据会在48小时后自动消失，请及时使用
            </div>
            <el-button type="warning" :disabled="deviceStatus>=3" @click="upload2">开始上传
            </el-button>
            <div class="set-upload-progress" v-show="percentage>0">
              <el-progress :percentage="percentage" :format="format"></el-progress>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {showLabel} from "@/utils";
import RfidEditConfig from "@/views/rfid/RfidEditConfig";
import {RfidService} from "@/views/rfid/api/rfid-service";

export default {
  props: ['isdel', 'scanType', 'packageType', 'value', 'startClick', 'closeClick',
    'giveUpClick', 'uploadClick', 'deviceStatus', 'percentage', 'stopEcpClick', 'saveDbCount', 'currentTask'
    , 'setRepairPackageData', 'hasSupplierOrRepairFactory', 'selectedSupplier', 'selectedRepairFactory', 'showSupplierOrRepairFactoryDialog',
    'form','scanTypeChange'
  ],
  name: "RfIdScanInfo",
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    scanTypeLabel() {
      return showLabel(this.scanType, RfidEditConfig.allScanTypes, null, false);
    },
    packageTypeLabel() {
      return showLabel(this.packageType, RfidEditConfig.allPackageTypes, null, false);
    },
    uploadLabel() {
      return "开始上传";
    },
    caijiBtnText() {
      if (this.isdel) {
        return "删除模式";
      }
      return "采集模式";
    },
    taskInfo() {
      if (this.currentTask) {
        return `${this.currentTask.APPLY_ID}  ${this.currentTask.SITE_NAME}    ${this.currentTask.TaskNum}`;
      }
      return '';
    },
    checkBtnText() {
      return this.checkStatus ? "编辑" : "校验"
    },
    isNewPackageIn() {
      return this.scanType === '12';
    },
    isRepairIn() {
      return this.scanType === '48';
    }
  },
  data() {
    return {
      loading: null,
      repairPackageData: '',
      checkStatus: null,
      checkMessage: null,
    }
  },
  watch: {
    'scanType': function (newval, oldval) {
      this.repairPackageData = ''
      if (this.scanTypeChange){
        this.scanTypeChange(newval,oldval)
      }
    },
    repairPackageData(val, oldVal) {
      if (this.setRepairPackageData) {
        this.setRepairPackageData(val);
      }
      if (val !== oldVal) {
        this.checkStatus = null;
        this.checkMessage = null;
      }
    }
  },
  methods: {
    async abandonScanClick() {
      await this.$confirm('是否放弃本次扫描数据？将会清空当前数据信息！！！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      this.$emit('AbandonClick')
    },
    format(percentage) {
      if (percentage === 100) {
        return "完成";
      }
      return percentage.toFixed(2) + "%";
    },
    async upload2() {
      if (this.scanType == '40') {
        if (!this.repairPackageData) {
          this.$message.error('请先录入维修包签后再开始上传')
          return;
        } else {
          if (this.checkStatus === false) {
            this.$message.error(this.checkMessage);
            return;
          } else if (this.checkStatus === null) {
            const result = await this.checkRepairPackageData(false);
            if (!result) {
              return;
            }
          }
        }
      }
      this.loading = this.$loading({
        lock: true,
        text: '数据上传中，请勿触碰，以免造成数据错误',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var b = await this.uploadClick();
      if (!b) {
        this.closeLoading()
      }
    },
    closeLoading() {
      if (this.loading) {
        this.loading.close()
      }
    },
    openLoading() {
      this.loading = this.$loading({
        lock: true,
        text: '数据上传中，请勿触碰，以免造成数据错误',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    async editOrCheckRepairPackageData() {
      // 编辑
      if (this.checkStatus) {
        this.checkStatus = null;
        this.$nextTick(() => {
          try {
            const input = this.$refs.inputRef?.$refs?.input;
            if (input) {
              input.focus();
              const pos = this.repairPackageData?.length;
              input.setSelectionRange(pos, pos);
            }
          } catch (e) {
            console.log(e);
          }
        });
        return;
      }
      await this.checkRepairPackageData();
    },
    async checkRepairPackageData(showSuccessTips = true) {
      this.checkStatus = null;
      if (!this.repairPackageData) {
        this.$message.error("请先录入维修包签")
        return false;
      }
      const {success, message} = await RfidService.checkRepairBagsign(this.repairPackageData.trim())
      this.checkStatus = success;
      if (success) {
        if (showSuccessTips) {
          this.$message.success("校验成功");
        }
      } else {
        this.checkMessage = this.repairPackageData + message;
        this.$message.error(this.checkMessage);
      }
      return success;
    }
  }
}
</script>

<style lang="less">
@import "./rfid";
</style>
<style scoped lang="less">
.bag-sign ::v-deep input {
  padding: 0 4px;

  &:disabled {
    background: #DDD;
  }
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;

  .supplier {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 4px;
  }
}
</style>
